export const albumWilliamLucaEngagement = {
  albumTitle: "William & Luca Engagement",
  albumDesc: "13 May 2023 in Utrecht, The Netherlands",
  photos: [
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/8c3127173317965.648e2012063db.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/9bb55a173317965.648e2011f41c8.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/b0fe6b173317965.648e201209656.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/3279da173317965.648e2011ee698.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/565b9b173317965.648e201202b5f.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/07abca173317965.648e2011ed8b3.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/3f5d1e173317965.648e2011ecba7.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/e9aca2173317965.648e2011ef768.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/eb672c173317965.648e201201afc.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/250707173317965.648e2012037db.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/ca9aaf173317965.648e2012165e4.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/8c479e173317965.648e20120454c.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/023ad5173317965.648e2012071d7.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/1a2348173317965.648e201205380.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/2d538c173317965.648e20120e3c4.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/ea74ea173317965.648e2012177fb.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/c90b29173317965.648e201218d01.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/8fa9c2173317965.648e201211ab9.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/4863c2173317965.648e201208137.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/d43d13173317965.648e20120cba5.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/cc2dde173317965.648e2012109ee.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/4998e0173317965.648e2011f080b.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/fba63b173317965.648e20120a58e.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/47f3dc173317965.648e20120b780.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/f45499173317965.648e201213b94.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/fs/2ba41b173317965.648e201215428.jpg",
  ].map((imgURL) => ({ src: imgURL })),
};
